"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
/**
 * 通用 api返还表单报错处理
 *********
 * 后端返还通用报错格式：
 * { errorInfos: [{key: '', errMsg: ''}] }
 *
 *********
 * 使用demo：
 * html：
 * <el-form-item prop="xxx" :rules="[...otherRules, validatorCommon('xxx', 'change')]">
 * js：
 * this.errorHandle(err, 'dataForm')
 */
var _default = exports.default = {
  data: function data() {
    return {
      errorKeys: [],
      errorInfo: {}
    };
  },
  methods: {
    // 通用validata
    validatorCommon: function validatorCommon(key, trigger) {
      var _this = this;
      return {
        required: true,
        trigger: trigger,
        validator: function validator(rule, value, callback) {
          if (_this.errorKeys.indexOf(key) >= 0) {
            console.log('报错', key, _this.errorInfo[key]);
            callback(new Error(_this.errorInfo[key]));
            _this.resetError(key);
          } else {
            callback();
          }
        }
      };
    },
    /**
     * 返还错误数据处理
     * @param {Object} err // api返还错误格式
     * @param {String} formRef // form表单ref
     * @param {Function} cb // 针对特殊报错定制化处理
     */
    errorHandle: function errorHandle(err, formRef, cb) {
      var _this2 = this;
      if (err.errorInfos && err.errorInfos.length > 0) {
        this.resetError();
        err.errorInfos.forEach(function (item) {
          _this2.errorKeys.push(item.key);
          _this2.errorInfo[item.key] = item.errMsg;
        });
        // 定制一些特殊错误处理
        cb && cb();
        this.$refs[formRef] && this.$refs[formRef].validate().catch(function () {});
      }
    },
    // 重置错误数据
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    }
  }
};